import { useUserStore } from '../../../store/useUserStore';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../../data/url';
import { useKidDetailQuery } from '../../../queries';
import { calculateAge } from '../../../utility/utilities';
import { VIDEO_RECORD_TYPE } from '../../../data/define';
import ImgKidFace from '../../../assets/image/img_kidface.png';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import BottomFixedBtn from '../../../component/common/BottomFixedBtn';
import { Kid } from '../../../types';

interface KidBoxProps {
  kid: Kid;
  onClick: (kid: Kid) => void;
  selectedKid: Kid | null;
}

function KidBox({ kid, onClick, selectedKid }: KidBoxProps) {
  return (
    <button
      type="button"
      className="flex items-center justify-start w-full gap-3 px-[20px]"
      style={{
        backgroundColor: selectedKid?.id === kid?.id ? '#F2F2F2' : '#FFF',
      }}
      onClick={() => onClick(kid)}
    >
      <div className="min-w-[52px] min-h-[52px] overflow-hidden bg-[#FFF] border border-[#EAEAEA] flex items-center justify-center rounded-[24px]">
        {kid.imageUrl ? (
          <img src={kid.imageUrl} alt="thumnail1" className="w-[52px] h-[52px]" />
        ) : (
          <img src={ImgKidFace} alt="thumnail1" className="w-[30px] h-[30px]" />
        )}
      </div>
      <div className="grow flex flex-col items-start my-[12px]">
        <div className="flex items-center cursor-pointer gap-[5px]">
          <span className="font-[700] text-[16px]">{kid?.kidName ?? '-'}</span>
        </div>
        <div className="text-[12px] font-[400] text-[#363636]">
          {kid?.gender === 'male' ? '남아' : '여아'}•{calculateAge(kid?.kidBirth)}세
        </div>
      </div>
    </button>
  );
}

// 3차 개발시 생략된 페이지임 //
export default function SelectKid() {
  const navigate = useNavigate();
  const user = useUserStore();
  const setUser = user.setUser;
  const [selectedKid, setSelectedKid] = useState<Kid | null>(null);
  const [reportId, setReportId] = useState<number | null>(null);

  const handleDecideMainKid = (kid: Kid) => {
    setSelectedKid(kid);
  };

  const { data: kidDetail } = useKidDetailQuery(selectedKid?.id as number, {
    enabled: !!selectedKid?.id,
  });

  useEffect(() => {
    if (kidDetail) {
      const notSuccessReport = kidDetail.reports?.find((r: any) => !r.isSuccess);
      if (notSuccessReport) {
        setReportId(notSuccessReport.id);
      } else {
        setReportId(null);
      }
    } else {
      setReportId(null);
    }
  }, [kidDetail]);

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title="" onClickPrev={() => navigate(-1)} />
      <div className="pageInner bg-[#FFF]">
        <div className="text-[#1C1C1C] text-[24px] font-[700] text-left mt-[30px]">
          영상 분석을 진행할
          <br />
          아이를 선택해 주세요.
        </div>
        <div
          className="flex flex-col items-start justify-start gap-3 mt-[40px]"
          style={{ width: '100vw', marginLeft: '-23px', marginRight: '-23px' }}
        >
          {user?.kids &&
            user?.kids?.length >= 1 &&
            user?.kids?.map((kid, index) => (
              <KidBox
                key={index}
                kid={kid}
                onClick={handleDecideMainKid}
                selectedKid={selectedKid}
              />
            ))}
        </div>
      </div>
      <BottomFixedBtn
        title="다음"
        onClick={() => {
          if (selectedKid) {
            navigate(
              `${Url.KidsRegisterUpload}?type=${encodeURIComponent(VIDEO_RECORD_TYPE.DAILY)}`,
              {
                state: reportId
                  ? { kidId: selectedKid?.id, mi: [], reportId: reportId }
                  : { kidId: selectedKid?.id, mi: [] },
              }
            );
            setUser((prev) => ({
              ...prev,
              mainKid: selectedKid,
            }));
          }
        }}
        disabled={!selectedKid}
      />
    </FullHeightContainer>
  );
}
